export default __webpack_public_path__ + "static/media/round-navigation-close.bf73f94d.svg";